import { createRouter, createWebHistory } from "vue-router";
import FrontLayout from "./components/FrontLayout.vue";
import HomePage from "./components/pages/Home.vue";

import store from "./../../store/root.vuex"; // Import Vuex store

// Định nghĩa danh sách routes
const routes = [
    { 
        path: '/', 
        component: FrontLayout,
        meta: { role: 0 }, // Không cần quyền hạn
        children: [
            { path: '', component: HomePage, meta: { role: 0 } },
			{
				path: "/category/:id",
				name: "category",
				component: HomePage,    // dùng chung Home để render game list
				props: true,
			},
			{
				path: "/new",
				name: "new",
				component: HomePage,    // dùng chung Home để render game list
				props: true,
			},
			{
				path: "/popular",
				name: "popular",
				component: HomePage,    // dùng chung Home để render game list
				props: true,
			},
        ]
    }
];

// Khởi tạo Vue Router
const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = store.state.user.isAuthenticated;
  const userRole = store.state.user.role; // Lấy role từ Vuex

  // Tìm `meta.role` từ danh sách matched routes
  const requiredRole = to.matched.find(r => r.meta?.role)?.meta?.role ?? 0;

  console.log("🔄 Chuyển hướng từ:", from.fullPath, "➡ Đến:", to.fullPath);
  console.log("✅ isAuthenticated:", isAuthenticated, "| 🏷️ Role:", userRole, "| 🔍 Required Role:", requiredRole);

  // Nếu route yêu cầu đăng nhập nhưng user chưa đăng nhập → Chuyển hướng về login
  if (to.meta.requiresAuth && !isAuthenticated) {
    console.log("🔴 Chưa đăng nhập, chuyển hướng đến /login");
    return next("/login");
  }

  // Nếu user đã đăng nhập mà vào trang dành cho guest → Chuyển hướng đến dashboard tương ứng
  if (to.meta.requiresGuest && isAuthenticated) {
    console.log("🟢 Đã đăng nhập, chuyển hướng đến dashboard phù hợp");
    return next(userRole === 1 ? "/admin/dashboard" : "/user/dashboard");
  }

  // Nếu route yêu cầu quyền cao hơn role hiện tại → Chặn truy cập
  if (isAuthenticated && requiredRole > 0 && requiredRole !== userRole) {
    console.log("⛔ Không có quyền truy cập, chuyển về dashboard của role phù hợp");
    return next(userRole === 1 ? "/admin/dashboard" : "/user/dashboard");
  }

  console.log("🟡 Không cần chuyển hướng, tiếp tục");
  next();
});

export default router;
